/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Combine_TitleInputs */

const en_why_listening_combine_title = /** @type {(inputs: Why_Listening_Combine_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening combines all three in one app.`)
};

const es_why_listening_combine_title = /** @type {(inputs: Why_Listening_Combine_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening reúne las tres en una sola app.`)
};

/**
* | output |
* | --- |
* | "Listening combines all three in one app." |
*
* @param {Why_Listening_Combine_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_combine_title = /** @type {((inputs?: Why_Listening_Combine_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Combine_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_combine_title(inputs)
	return en_why_listening_combine_title(inputs)
});